import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import HeaderSearch from './HeaderSearch';
import CartPanel from './CartPanel';
import { useCart } from '../context/CartContext';
import { PhoneIcon, MenuIcon, CloseIcon, CartIcon } from './Icons';

const navLinks = [
  { path: '/', label: 'Accueil' },
  { path: '/apropos', label: 'À propos' },
  { path: '/menu', label: 'Notre menu' },
  { path: '/contact', label: 'Contact' },
];

function Navigation() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { totalCount, openCart } = useCart();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="site-header">
      <div className="header-inner">
        <div className="header-logo">
          <Logo />
        </div>

        <nav className={`main-nav ${menuOpen ? 'open' : ''}`} aria-label="Navigation principale">
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`nav-item ${isActive(path) ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <HeaderSearch />
          <button
            type="button"
            className="cart-toggle"
            onClick={openCart}
            aria-label={`Ouvrir le panier${totalCount > 0 ? `, ${totalCount} article${totalCount > 1 ? 's' : ''}` : ''}`}
          >
            <CartIcon size={20} />
            {totalCount > 0 && <span className="cart-badge">{totalCount}</span>}
          </button>
          <Link to="/menu" className="btn-order" onClick={() => setMenuOpen(false)}>
            <PhoneIcon size={16} />
            <span className="btn-order-text">Commander maintenant</span>
          </Link>
          <button
            type="button"
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <CloseIcon size={22} /> : <MenuIcon size={22} />}
          </button>
        </div>
      </div>
      <CartPanel />
    </header>
  );
}

export default Navigation;
